export class GeneralRules {
  
}
